// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EuroCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/EuroCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var EuroCircleTwoTone = function EuroCircleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EuroCircleTwoToneSvg
  }));
};

EuroCircleTwoTone.displayName = 'EuroCircleTwoTone';
export default React.forwardRef(EuroCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/EuroCircleTwoTone.js
// module id = 1023
// module chunks = 0